import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EvaluacionService {

  private docentesEvaluados = false;

  // Método para actualizar el estado de evaluación
  setDocentesEvaluados(status: boolean) {
    this.docentesEvaluados = status;
  }

  // Método para consultar el estado de evaluación
  getDocentesEvaluados(): boolean {
    return this.docentesEvaluados;
  }

  /** Reinicia el estado al cerrar sesión */
  reset() {
    this.docentesEvaluados = false;
  }

}
